export default function InitialCost() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section id="initial-cost" className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            初期費用
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto">
            シンプルで分かりやすい料金体系
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl shadow-xl p-8 sm:p-12 text-center mb-8 sm:mb-12">
            <div className="w-16 h-16 sm:w-20 sm:h-20 flex items-center justify-center bg-gradient-to-br from-teal-500 to-teal-600 rounded-full mx-auto mb-4 sm:mb-6">
              <i className="ri-price-tag-3-line text-3xl sm:text-4xl text-white"></i>
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">初期費用</h3>
            <div className="flex items-baseline justify-center mb-4 sm:mb-6">
              <span className="text-5xl sm:text-6xl font-bold text-teal-600">¥10,000</span>
            </div>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
              Webサイトの初期構築費用として、一度だけお支払いいただきます。<br className="hidden sm:block" />
              この費用には、デザイン設計、コンテンツ作成、初期設定が含まれます。
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 mb-6 sm:mb-8">
            <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6 text-center">
              初期費用に含まれるもの
            </h3>
            <ul className="space-y-3 sm:space-y-4">
              {[
                'ヒアリング・要件定義',
                'デザイン設計',
                'コンテンツ作成',
                'Webサイト構築',
                '初期SEO設定',
                '動作確認・テスト',
                '公開作業'
              ].map((item, index) => (
                <li key={index} className="flex items-center">
                  <i className="ri-checkbox-circle-fill text-teal-500 text-xl sm:text-2xl mr-3 sm:mr-4 flex-shrink-0"></i>
                  <span className="text-sm sm:text-base text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="text-center">
            <button
              onClick={scrollToContact}
              className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-white text-sm sm:text-base rounded-lg font-semibold hover:from-teal-600 hover:to-teal-700 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-chat-smile-3-line mr-2"></i>
              お問い合わせはこちら
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}